var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgClicker = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.702,
    height: 31.549,
    viewBox: "0 0 29.702 31.549",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M41.346 7.7a2.491 2.491 0 0 0-.994.206 2.524 2.524 0 0 0-2.342-1.6 2.491 2.491 0 0 0-1.1.255 2.52 2.52 0 0 0-2.235-1.367 2.489 2.489 0 0 0-.815.137V2.538a2.52 2.52 0 1 0-5.04 0V12.59l-1.815-2.077-.039-.042a2.527 2.527 0 0 0-1.786-.745h-.013a2.493 2.493 0 0 0-1.777.733c-.833.834-.879 2.071-.126 3.4.975 1.713 2.035 3.329 2.97 4.754.683 1.042 1.329 2.026 1.8 2.839.409.706 1.5 3 1.507 3.019a.852.852 0 0 0 .77.487H41.09a.853.853 0 0 0 .812-.591c.2-.625 1.964-6.167 1.964-8.308V10.24a2.532 2.532 0 0 0-2.52-2.54zm-.815 2.538a.815.815 0 1 1 1.63 0v5.817a38.952 38.952 0 0 1-1.7 7.194H30.85c-.353-.735-1.016-2.1-1.34-2.656-.5-.854-1.154-1.857-1.85-2.919-.921-1.4-1.966-3-2.914-4.662-.248-.435-.474-1.022-.15-1.347a.814.814 0 0 1 .576-.234.833.833 0 0 1 .572.229l3.287 3.76a.852.852 0 0 0 1.494-.561V2.538a.816.816 0 1 1 1.631 0V10.5a.852.852 0 0 0 1.7 0V7.732a.815.815 0 1 1 1.63 0v3.876a.852.852 0 1 0 1.7 0V8.844a.816.816 0 1 1 1.631 0v3.876a.852.852 0 1 0 1.7 0v-2.48z",
    transform: "rotate(-25 31.512 55.732)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgClicker);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/clicker.924f2bfdd55ef6a8bcf0945da9e62cc6.svg";